import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import the AOS styles

export const SixthSection = () => {
  useEffect(() => {
    // Initialize AOS when the component mounts
    AOS.init({
      duration: 1000, // Animation duration
      easing: "ease-out", // Animation easing
      once: false, // Whether animation should happen once or not
    });
  }, []);

  return (
    <>
      <div className="container mb-4">
        <div className="row" style={{ height: "100%" }}>
            {/* Text Section */}
          <div
            className="col-md-6 d-flex flex-column justify-content-center text-center"
            data-aos="fade-up" // AOS animation for text
            data-aos-delay="1000" // Delay for animation
          >
            <h1>Lone Wolf Writes</h1>
            <br />
            <p style={{ color:"#9a9a9a" }}>
            Bite-sized pieces of wisdom & inspiration,
            <br />
            thoughtfully crafted to motivate, uplift,
            <br />
            and resonate with readers
            <br />
            in moments of need. 
            </p>
          </div>
          {/* Image Section */}
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            data-aos="fade-up" // AOS animation for the image
            data-aos-delay="500" // Delay for animation
          >
            <img
              src="/lone-wolf-writes-logo.png"
              alt="Logo, poems, quotes, blogs,lone wolf writes, pranav, pranav gaikwad, alex_boybelieber, the emperor alex, alex7741, gpran7741, alex23, praxisedge, praxisedgetech, praxisedge technology, mad, confident, crazy, arrogant, selfish, inspiration, love, lost, quote, lww, lww quotes, depression quotes, mad quotes, confident quotes, crazy quotes, arrogant quotes, selfish quotes, inspiration quotes, love quotes, lost quotes, depression poems, mad poems, confident poems, crazy poems, arrogant poems, selfish poems, inspiration poems, love poems, lost poems, depression blogs, mad blogs, confident blogs, crazy blogs, arrogant blogs, selfish blogs, inspiration blogs, love blogs, lost blogs, lone wolf quotes, lone wolf poems, lone wolf blogs, lone wolf quote, lone wolf poem, lone wolf blog, lonewolf writes, lone wolf, Lone Wolf Writes, LWW Blog, Poetry by Lone Wolf, Lone Wolf Quotes, Blogs by Lone Wolf Writes, Inspirational quotes, Motivational poems, Life quotes blog, Heartfelt poetry, Creative writing blog, Lone wolf poetry, Original quotes collection, Thoughtful blogs, Deep quotes and poems, Lone writer quotes, Best poetry blogs by Lone Wolf, Motivational quotes and poetry, Blogs about life and emotions, Poetic quotes about solitude, Inspiring words by Lone Wolf Writes, "
              style={{ maxHeight: "400px", maxWidth:"100%" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
